import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { getUser } from '@/generated/client/drive-on-auth-controller/drive-on-auth-controller';
import { DriverInputOicdUser } from '@/generated/model/driverInputOicdUser';

export function useUserState(
  initialState: DriverInputOicdUser | undefined | null
): [DriverInputOicdUser | undefined | null, Dispatch<SetStateAction<DriverInputOicdUser | undefined | null>>] {
  const [value, setValue] = useState<DriverInputOicdUser | undefined | null>(initialState);

  useEffect(() => {
    async function init() {
      try {
        const response = await getUser();
        if (response.status === 200) {
          setValue({
            name: response.data.name,
            email: response.data.email,
            userName: response.data.userName,
            personId: response.data.personId,
            admin: response.data.admin,
          } satisfies DriverInputOicdUser);
          console.log('getUser Api called');
        } else {
          setValue(null);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        console.warn('Login was unsuccessful');
        setValue(null);
      }
    }

    init();
  }, []);

  async function onChange(
    newState:
      | DriverInputOicdUser
      | undefined
      | null
      | ((newState: DriverInputOicdUser | undefined | null) => DriverInputOicdUser | undefined | null)
  ) {
    if (newState instanceof Function) {
      console.warn('not permitted');
      return;
    }
    if (newState === undefined) {
      console.warn('not permitted');
      return;
    }
    setValue(newState);
  }

  return [value, onChange];
}
